import { useContext, useEffect, useState } from "react";
import { AuthContext } from "contexts/AuthContext";
import { Link } from "react-router-dom";
import validations from "utils/validations/signupValidations";
import formOptions from "utils/formOptions.json";
import Container from "components/Library/Container";
import Form from "components/Library/Form";
import Button from "components/Library/Button";
import Input from "components/Library/Input";
import FormRow from "components/Library/FormRow";
import Select from "components/Library/Select";
import useForm from "hooks/useForm";

function Signup() {
  const authContext = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [formValues, handleInputChange, errors, setErrors] = useForm({
    name: "",
    lastName: "",
    age: "",
    gender: "",
    email: "",
    telephone: "",
    password: "",
    password2: "",
    isFirstHome: "",
    hasIngreso: "",
    ingresoAmount: "",
    hasCesantias: "",
    cesantiasAmount: "",
    hasSavingsAccount: "",
    savingsAmount: "",
    city: "",
    purchaseReason: "",
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    const formErrors = validations(formValues);
    setErrors(formErrors);

    if (Object.keys(formErrors).length === 0) {
      authContext.registerUser(formValues);
    } else {
      setLoading(false);
    }
  };

  useEffect(() => {
    setErrors(authContext.errorMessage);
    setLoading(false);
  }, [setErrors, authContext.errorMessage]);

  return (
    <Container>
      <Form onSubmit={handleSubmit} autoComplete="off">
        <h1 className="form__title">Registro</h1>
        <FormRow>
          <Input
            placeholder="Nombre"
            name="name"
            value={formValues.name}
            error={errors.name}
            onChange={handleInputChange}
          />
          <Input
            placeholder="Apellido"
            name="lastName"
            value={formValues.lastName}
            error={errors.lastName}
            onChange={handleInputChange}
          />
        </FormRow>
        <FormRow>
          <Input
            type="number"
            placeholder="Edad"
            name="age"
            value={formValues.age}
            error={errors.age}
            onChange={handleInputChange}
          />
          <Select
            placeholder="Género"
            options={formOptions.GENDERS}
            name="gender"
            value={formValues.gender}
            error={errors.gender}
            onChange={handleInputChange}
          />
        </FormRow>
        <FormRow>
          <Input
            autoComplete="off"
            type="email"
            placeholder="Correo electrónico"
            name="email"
            value={formValues.email}
            error={errors.email}
            onChange={handleInputChange}
          />
          <Input
            autoComplete="off"
            type="number"
            placeholder="Número de teléfono"
            name="telephone"
            value={formValues.telephone}
            error={errors.telephone}
            onChange={handleInputChange}
          />
        </FormRow>
        <FormRow>
          <Input
            autoComplete="off"
            type="password"
            placeholder="Contraseña"
            name="password"
            value={formValues.password}
            error={errors.password}
            onChange={handleInputChange}
          />
          <Input
            autoComplete="off"
            type="password"
            placeholder="Confirmar contraseña"
            name="password2"
            value={formValues.password2}
            error={errors.password2}
            onChange={handleInputChange}
          />
        </FormRow>
        <Select
          placeholder="¿Esta sería tu primera vivienda?"
          options={formOptions.YES_NO}
          name="isFirstHome"
          value={formValues.isFirstHome}
          error={errors.isFirstHome}
          onChange={handleInputChange}
        />
        <FormRow>
          <Select
            placeholder="¿Cuentas con un ingreso familiar?"
            options={formOptions.YES_NO}
            name="hasIngreso"
            value={formValues.hasIngreso}
            error={errors.hasIngreso}
            onChange={handleInputChange}
          />
          <Input
            type="number"
            placeholder="Monto del ingreso familiar"
            name="ingresoAmount"
            value={formValues.ingresoAmount}
            error={errors.ingresoAmount}
            onChange={handleInputChange}
            isEnabled={formValues.hasIngreso}
          />
        </FormRow>
        <FormRow>
          <Select
            placeholder="¿Cuentas con cesantías?"
            options={formOptions.YES_NO}
            name="hasCesantias"
            value={formValues.hasCesantias}
            error={errors.hasCesantias}
            onChange={handleInputChange}
          />
          <Input
            type="number"
            placeholder="Monto de cesantías"
            name="cesantiasAmount"
            value={formValues.cesantiasAmount}
            error={errors.cesantiasAmount}
            onChange={handleInputChange}
            isEnabled={formValues.hasCesantias}
          />
        </FormRow>
        <FormRow>
          <Select
            placeholder="¿Tienes ahorros?"
            options={formOptions.YES_NO}
            name="hasSavingsAccount"
            value={formValues.hasSavingsAccount}
            error={errors.hasSavingsAccount}
            onChange={handleInputChange}
          />
          <Input
            type="number"
            placeholder="Monto de tus ahorros"
            name="savingsAmount"
            value={formValues.savingsAmount}
            error={errors.savingsAmount}
            onChange={handleInputChange}
            isEnabled={formValues.hasSavingsAccount}
          />
        </FormRow>
        <FormRow>
          <Select
            placeholder="¿En que ciudad quieres comprar?"
            options={formOptions.CITIES}
            name="city"
            value={formValues.city}
            error={errors.city}
            onChange={handleInputChange}
          />
          <Select
            placeholder="Motivo de compra"
            options={formOptions.PURCHASE_REASONS}
            name="purchaseReason"
            value={formValues.purchaseReason}
            error={errors.purchaseReason}
            onChange={handleInputChange}
          />
        </FormRow>
        <div className="form__buttons">
          <Link className="button button--secondary" to="/">
            Regresar
          </Link>
          <Button type="submit" value="Registrarse" disabled={loading} />
        </div>
      </Form>
    </Container>
  );
}

export default Signup;
